<template>
    <region-retailers-section
        class="region-retailers-section-module"
        :title="attributes.regionRetailers_title"
        :intro="attributes.regionRetailers_intro"
        :retailers="mappedRetailers"
    />
</template>

<script>
    import RegionRetailersSection from '../../../organisms/RegionRetailersSection/RegionRetailersSection';
    import formatMediaObject from '../../../../utils/formatters/format-media-object';

    export default {
        name: 'region-retailers-section-module',

        components: { RegionRetailersSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },

        computed: {
            /**
             * Format the logos for the RegionRetailersSection.
             *
             * @returns {{logo: {src: string, alt: string}, name: string, link: string, id: number}[]}
             */
            mappedRetailers() {
                return (this.attributes.regionRetailers_retailers || []).map((retailer) => ({
                    name: retailer.name,
                    logo: formatMediaObject.call(this, retailer.icon),
                    link: retailer.link,
                }));
            },
        },
    };
</script>
